<template>
    <div class="inner">
        <div class="double-info-block">
            <div class="left">
                <Content v-html="data.left_content"></Content>
            </div>
            <div class="right">
                <Content v-html="data.right_content"></Content>
            </div>
        </div>

    </div>
</template>

<script>
import Content from '@/components/ui/Content.vue';

export default {
    name: 'double-info-block',

    props: {
        data: Object,
    },
    components: {
        Content,
    },
    // mounted() {
    //     console.log(this.data)
    // },

}
</script>

<style lang="scss">
    .double-info-block {
        display: flex;
        padding: 0 var(--padding-x4);

        & > div {
            box-sizing: border-box;
            width: 50%;
            padding: var(--padding);
            display: flex;

            .enter, .ui-enter {
                width: 100%;
                img {
                    width:100%;
                    height: auto;
                }
            }
        }
    }
</style>
